import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import { Input } from "@frui.ts/bootstrap";
import { observer } from "mobx-react-lite";
import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { translateGeneral } from "utils/localizations";
import NumberRangeInputControl from "controls/numberRangeInput";
import type DistributorRefundsViewModel from "viewModels/finance/refundApprovals/distributorRefunds/distributorRefundsViewModel";
import FilterView from "../../../common/filter";
import { onNumberInputKeyPress } from "../../../../utils/numberInput";

export interface DistributorRefundsFiltersProps {
  vm: DistributorRefundsViewModel;
}

const DistributorRefundsFilters = observer((props: DistributorRefundsFiltersProps) => {
  const { vm } = props;
  const fullTextClassNames = vm.filter.fullTextSearchEnabled ? "border-success border-2" : "";

  return (
    <FilterView vm={vm}>
      <div className="row">
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateAttribute("distributorName")}</Form.Label>
          <Input
            target={vm.filter}
            property="distributorName"
            placeholder={translateGeneral("search")}
            className={fullTextClassNames}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateAttribute("variableSymbol")}</Form.Label>
          <Input
            target={vm.filter}
            property="variableSymbol"
            placeholder={translateGeneral("search")}
            type="number"
            onKeyDown={onNumberInputKeyPress}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateModelAttribute("distributorPaymentRequest", "variableSymbol")}</Form.Label>
          <Input
            target={vm.filter}
            property="distributorsRequestVariableSymbol"
            placeholder={translateGeneral("search")}
            type="number"
            onKeyDown={onNumberInputKeyPress}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateModelAttribute("distributorPaymentRequest", "type")}</Form.Label>
          <AdvancedSelect
            target={vm.filter}
            property="distributorsRequestType"
            placeholder={translateGeneral("search")}
            items={vm.requestTypeOptions}
          />
        </Form.Group>
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateModelAttribute("refund", "refundAmount")}</Form.Label>
          <NumberRangeInputControl
            target={vm.filter}
            property="amount"
            placeholder={translateGeneral("search")}
            step={0.1}
            min={0}
          />
        </Form.Group>
      </div>
    </FilterView>
  );
});

export default DistributorRefundsFilters;
